import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ja",
  "use": "icon-ja-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"icon-ja\"><path d=\"M22.114 0H4.43a.898.898 0 0 0-.886.886c0 .48.406.886.886.886h16.798v16.872c0 .48.406.886.886.886s.886-.406.886-.886V.886A.898.898 0 0 0 22.114 0z\" /><path d=\"M18 3a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16zm-3.38 3.996H5.646v12.39h1.33v-.994h6.314v.98h1.33V6.996zm-1.33 6.202v3.892H6.976v-3.892h6.314zm0-4.914v3.612H6.976V8.284h6.314z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol